import React, {useState, useEffect} from "react";
import {authenticationService} from "../../Scripts/authentication.service";
import Title from "../../Comps/Title";
import {UserIcon, UserPlusIcon} from "@heroicons/react/16/solid";
import {handleResponse} from "../../Scripts/handle-response";
import Input from "../../Comps/Input";
import Button from "../../Comps/Button"
import Loading from "../../Loading/Loading";
import {useParams} from "react-router-dom";
import {Combobox, ComboboxInput, ComboboxOption, ComboboxOptions} from "@headlessui/react";

const WheelEdit = () => {
    const [user] = useState(authenticationService.currentUserValue)
    const { id } = useParams()
    const [openPubs, setOpenPubs] = useState(false)
    const [openModifiers, setOpenModifiers] = useState(false)
    const [link, setLink] = useState(false)
    const [wheelPubs, setWheelPubs] = useState([])
    const [allPubs, setAllPubs] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [name, setName] = useState("")
    const [desc, setDesc] = useState("")
    const [img, setImg] = useState("")
    const [weight, setWeight] = useState(10.0)
    const [lat, setLat] = useState(0.0)
    const [long, setLong] = useState(0.0)
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [linkedPubs, setLinkedPubs] = useState([])
    const [pubQuery, setPubQuery] = useState("");

    const weightOptions = [
        { value: 2.5, label: "0.25x" },
        { value: 5.0, label: "0.5x" },
        { value: 10.0, label: "1x" },
        { value: 15.0, label: "1.5x" },
        { value: 20.0, label: "2x" },
    ];

    const getWheelPubs = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'id':id})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/wheel/getWheelPubs`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setWheelPubs(result)
                    getAllPubs()
                }, (error) => {console.log(error)}
            )
    }

    const getAllPubs = () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/getPubs`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setAllPubs(result)
                    setLoaded(true)
                }, (error) => {console.log(error)}
            )
    }

    const handleStartTime = (event) => {
        const [hours, minutes] = event.target.value.split(":").map(Number);
        const newStartDate = startDate;
        newStartDate.setHours(hours, minutes);
        setStartDate(newStartDate);
    };

    const handleEndTime = (event) => {
        const [hours, minutes] = event.target.value.split(":").map(Number);
        const newEndDate = endDate;
        newEndDate.setHours(hours, minutes);
        setEndDate(newEndDate);
    };

    const linkPub = (pub) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'pubId':pub, 'wheelId':id, 'weight':weight})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/wheel/newPubToWheel`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    getWheelPubs()
                },
                (error) => {console.log(error)}
            )
    }

    const newPub = () => {
        let pub = {
            name: name,
            desc: desc,
            img: img,
            lat: lat,
            long: long,
            start_time: startDate,
            end_time: endDate,
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'pub':pub})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/newPub`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    getAllPubs()
                    setOpenPubs(false)
                },
                (error) => {console.log(error)}
            )
    }

    const newModifier = () => {
        console.log('wheelId',id, 'title',name, 'description', desc, 'weight', weight, 'pubIds', JSON.stringify(linkedPubs))

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'wheelId':id, 'title': name, 'description': desc, 'weight': weight, 'pubIds': linkedPubs})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/wheel/newModifier`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setOpenModifiers(false)
                },
                (error) => {console.log(error)}
            )
    }

    const selectedLinkedPubs = allPubs.filter(pub => linkedPubs.includes(pub.id));

    const filteredPubs = (pubQuery === ""
            ? [...wheelPubs]
            : wheelPubs.filter(pub =>
                pub.name?.toLowerCase().includes(pubQuery.toLowerCase())
            )
    ).sort((a, b) => (a.name || "").localeCompare(b.name || ""));

    const handleLinkedPubsChange = pubs => {
        setLinkedPubs(pubs.map(pub => pub.id));
    };

    useEffect(() => {
        getWheelPubs()
    }, [])

    let extra = <></>
    if (user.admin) {
        extra = (
            <div className="justify-end flex gap-4 sm:grid-cols-2">
                <div>
                    <h3 className="mb-2 text-sm font-semibold text-gray-700">Pubs</h3>
                    <div className="space-x-2">
                        <Button title={"New"} onClick={() => setOpenPubs(true)} />
                        <Button title={"Link"} onClick={() => setLink(true)} />
                    </div>
                </div>

                <div>
                    <h3 className="mb-2 text-sm font-semibold text-gray-700">Modifiers</h3>
                    <div className="space-x-2">
                        <Button title={"New"} onClick={() => setOpenModifiers(true)} />
                        <Button title={"Link"} onClick={() => setLink(true)} />
                    </div>
                </div>
            </div>
        )
    }

    if (loaded) {
        return (
            <>
                <Title title={"Wheel Edit"} desc={"Edit the wheel"} extra={extra} />

                <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {wheelPubs.map((pub) => (
                        <li key={pub.id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
                            <div className="flex w-full items-center justify-between space-x-6 p-6">
                                {/*<img className="h-14 w-14 flex-shrink-0 rounded-2xl bg-gray-300 object-cover" src={game.pic} alt="" />*/}
                                <div className="flex-1 truncate">
                                    <div className="flex items-center space-x-3">
                                        <h3 className="truncate text-sm font-medium text-gray-900">{pub.name}</h3>
                                    </div>
                                    <p className="mt-1 truncate text-sm text-gray-500">Weight: {pub.weight}</p>
                                </div>
                            </div>
                            <div>
                                <div className="-mt-px flex divide-x divide-gray-200">
                                    <div className="flex w-0 flex-1">
                                        <div className="relative cursor-not-allowed -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
                                            <UserIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            Edit
                                        </div>
                                    </div>
                                    <div className="-ml-px flex w-0 flex-1">
                                        <div className="relative cursor-not-allowed inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
                                            <UserPlusIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            Unlink
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className={openPubs ? "absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity z-[101] flex justify-center items-center" : "-z-10 absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity flex justify-center items-center opacity-0"}>
                    <div className="bg-white shadow sm:rounded-lg px-4 py-5 sm:p-6 w-full lg:w-96 h-auto">
                        <h3 className="text-base font-semibold leading-6 text-gray-900">New Pub</h3>
                        <div className="mt-2 max-w-xl text-sm text-gray-500">
                            <Input
                                label={"Name"}
                                value={name}
                                placeholder={"Pub Name"}
                                onChange={e => setName(e.target.value)}
                            />
                            <Input
                                label={"Desc"}
                                value={desc}
                                placeholder={"Pub Desc"}
                                onChange={e => setDesc(e.target.value)}
                            />
                            <Input
                                label={"Image"}
                                value={img}
                                placeholder={"Pub Image"}
                                onChange={e => setImg(e.target.value)}
                            />
                        </div>
                        <div className="mt-5">
                            <button
                                type="button"
                                className="inline-flex mr-3 items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                                onClick={() => newPub()}
                            >
                                Create
                            </button>
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                                onClick={() => setOpenPubs(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>

                <div className={openModifiers ? "absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity z-[101] flex justify-center items-center" : "-z-10 absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity flex justify-center items-center opacity-0"}>
                    <div className="bg-white shadow sm:rounded-lg px-4 py-5 sm:p-6 w-full lg:w-96 h-auto">
                        <h3 className="text-base font-semibold leading-6 text-gray-900">New Modifier</h3>
                        <div className="mt-2 max-w-xl text-sm text-gray-500">
                            <Input
                                label={"Title"}
                                value={name}
                                placeholder={"Modifier Title"}
                                onChange={e => setName(e.target.value)}
                            />
                            <Input
                                label={"Desc"}
                                value={desc}
                                placeholder={"Modifier Desc"}
                                onChange={e => setDesc(e.target.value)}
                            />
                            <div className="w-full">
                                <label className="block mb-2 font-medium">
                                    Weight: {weightOptions.find(option => option.value === weight)?.label}
                                </label>

                                <input
                                    type="range"
                                    min={0}
                                    max={weightOptions.length - 1}
                                    step={1}
                                    value={weightOptions.findIndex(option => option.value === weight)}
                                    onChange={e => setWeight(weightOptions[Number(e.target.value)].value)}
                                    className="w-full"
                                />

                                <div className="flex justify-between mt-2 text-sm">
                                    {weightOptions.map(option => (
                                        <span key={option.value}>
                {option.label}
            </span>
                                    ))}
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Linked Pubs
                                </label>

                                <Combobox
                                    value={selectedLinkedPubs}
                                    onChange={handleLinkedPubsChange}
                                    multiple
                                    immediate
                                >
                                    <div className="relative mt-1">
                                        <ComboboxInput
                                            className="w-full rounded-md border border-gray-300 px-3 py-2"
                                            placeholder="Search pubs"
                                            displayValue={pubs => pubs.map(pub => pub.name).join(", ")}
                                            onChange={event => setPubQuery(event.target.value)}
                                            onFocus={() => setPubQuery("")}
                                            onClick={() => setPubQuery("")}
                                        />

                                        <ComboboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                                            {filteredPubs.length === 0 ? (
                                                <div className="px-4 py-2 text-sm text-gray-500">
                                                    No pubs found
                                                </div>
                                            ) : (
                                                filteredPubs.map(pub => (
                                                    <ComboboxOption
                                                        key={pub.id}
                                                        value={pub}
                                                        className={({ focus }) =>
                                                            `cursor-pointer px-4 py-2 text-sm ${
                                                                focus ? "bg-blue-600 text-white" : "text-gray-900"
                                                            }`
                                                        }
                                                    >
                                                        {({ selected }) => (
                                                            <div className="flex items-center justify-between">
                                                                <span>{pub.name}</span>
                                                                {selected && <span>✓</span>}
                                                            </div>
                                                        )}
                                                    </ComboboxOption>
                                                ))
                                            )}
                                        </ComboboxOptions>
                                    </div>
                                </Combobox>

                            </div>

                        </div>
                        <div className="mt-5">
                            <button
                                type="button"
                                className="inline-flex mr-3 items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                                onClick={() => newModifier()}
                            >
                                Create
                            </button>
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                                onClick={() => setOpenModifiers(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>

                <div className={link ? "absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity z-[101] flex justify-center items-center" : "-z-10 absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity flex justify-center items-center opacity-0"}>
                    <div className="bg-white shadow sm:rounded-lg px-4 py-5 sm:p-6 w-full lg:w-3/5 h-[95vh] overflow-y-scroll">
                        <h3 className="text-base font-semibold leading-6 text-gray-900">Link Pub</h3>
                        <div className="mt-5">
                            <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                {allPubs.map((pub) => (
                                    <li key={pub.id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
                                        <div className="flex w-full items-center justify-between space-x-6 p-6">
                                            {/*<img className="h-14 w-14 flex-shrink-0 rounded-2xl bg-gray-300 object-cover" src={game.pic} alt="" />*/}
                                            <div className="flex-1 truncate">
                                                <div className="flex items-center space-x-3">
                                                    <h3 className="truncate text-sm font-medium text-gray-900">{pub.name}</h3>
                                                </div>
                                                <p className="mt-1 truncate text-sm text-gray-500">Lat: {pub.lat}</p>
                                                <p className="mt-1 truncate text-sm text-gray-500">Long: {pub.long}</p>
                                                <p className="mt-1 truncate text-sm text-gray-500">Start Time: {new Date(pub.start_time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit'})}</p>
                                                <p className="mt-1 truncate text-sm text-gray-500">End Time: {new Date(pub.end_time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit'})}</p>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="-mt-px flex divide-x divide-gray-200">
                                                <div className="flex w-0 flex-1">
                                                    {wheelPubs.some(obj => obj.id === pub.id) ? (
                                                        <div className="relative cursor-not-allowed -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
                                                            <UserIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                            Linked
                                                        </div>
                                                    ) : (
                                                        <div className="relative cursor-pointer -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900" onClick={() => linkPub(pub.id)}>
                                                            <UserIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                            Link
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="-ml-px flex w-0 flex-1">
                                                    <div className="relative cursor-not-allowed inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-4 text-sm font-semibold text-gray-900">
                                                        <UserPlusIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                        ---
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className="mt-5">
                                <button
                                    type="button"
                                    className="inline-flex items-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                                    onClick={() => setLink(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        )
    } else {
        return (<Loading />)
    }
}

export default WheelEdit;
